/**
 * useOrderUpdates.js
 *
 * React hook that connects to the socket server and listens for real-time
 * order status updates. Shows a notification banner when an order changes.
 * Used by authenticated screens to keep order status in sync.
 */

import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { connectSocket, disconnectSocket, onOrderUpdate, offOrderUpdate } from '../services/socketService';

export const useOrderUpdates = () => {
  const user = useSelector((state) => state.login.data);
  const [latestUpdate, setLatestUpdate] = useState(null);

  const handleOrderUpdate = useCallback((payload) => {
    console.log('[CO-LAB] Order update received:', payload);
    setLatestUpdate(payload);

    // Auto-clear after 8 seconds
    setTimeout(() => setLatestUpdate(null), 8000);
  }, []);

  useEffect(() => {
    if (!user) return;

    connectSocket();
    onOrderUpdate(handleOrderUpdate);

    return () => {
      offOrderUpdate(handleOrderUpdate);
      disconnectSocket();
    };
  }, [user, handleOrderUpdate]);

  return { latestUpdate, clearUpdate: () => setLatestUpdate(null) };
};
